import React, {useEffect, useState} from "react";
import {HostBubblePlaceHolder} from "./HostBubble";
import {createUseStyles} from "react-jss";


const useStyles = createUseStyles({
	virtualHost: {
		zIndex: 1,
	},
	hostContainer: {
		width: ({bubbleSize:s}) => s+10,
		height: ({bubbleSize:s}) => s+10,
		border: "5px solid #003665",
		borderRadius: "50%"
	},
});

type VirtualHostProps = {
	embedURL: string
	size: string
}

export default function GameCompleteHost({embedURL, size}:VirtualHostProps) {
	const bubbleSize = size === "large" ? 88 : 72;
	const classes = useStyles({bubbleSize});
	return (
		<div className={classes.virtualHost}>
			<div className={classes.hostContainer}>
				<div>
					<HostBubblePlaceHolder embedURL={embedURL} width={bubbleSize}/>
				</div>
			</div>
		</div>
	);
}
